import { Injectable } from '@angular/core';

import { ProductTrimmingSpec } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ProductTrimmingSpecService extends TmsWebBaseEditService<ProductTrimmingSpec, ProductTrimmingSpec> {
  constructor() {
    super('TrimmingSpec', $localize`Trimming Spec`);
  }
}
